import React, {useState, } from 'react';
import { trackEvent } from '../../analytics/analytics_login.js';
import { useMsal } from '@azure/msal-react';
import msIcon from '../../assets/images/logos_microsoft-icon.svg';
import { Spin } from 'antd';
import {microsoftLogin} from '../../services/login-api';
import { global_var } from "../../services/login-config.js"

const MicrosoftLogin = () => {

    const { instance } = useMsal();
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        try {

            setLoading(true);
            const response = await instance.loginPopup({
                scopes: ['openid', 'profile', 'email'],
                prompt: "select_account"
            });
           
            if (response) {

                const loginResponse = await microsoftLogin({ 
                    id_token: response.idToken,
                    companyId: global_var.companyId
                });

                if (loginResponse.status === 200 && loginResponse.data && loginResponse.data.access_token) {
    
                    trackEvent('microsoft_login_button_clicked',{status:"microsoft_login_successful"});
                    let domainName = 'https://' + window.location.host.replace(/.login/g,'');
                
                    if (loginResponse.data.active_user_data.fkRoleId === 3) {
                        domainName += '/candidate/#/home/redirect';
                        trackEvent("microsoft_user_role_wise_login",{role: loginResponse.data.active_user_data.fkRoleName});
                    } else {
                        domainName += '/company/#/home/redirect';
                        trackEvent("microsoft_role_wise_login",{role: loginResponse.data.active_user_data.fkRoleName});
                    }
                    domainName += '?access_token=' + loginResponse.data.access_token;
                    localStorage.setItem('token', loginResponse.data.access_token)
                    window.location.href = domainName;
                } else {
                    console.log(loginResponse);
                    setLoading(false);
                }
                
            } else {
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
            if (error.response) {
                const errorMessage = error.response.data.message;
                trackEvent("Sign_in_with_microsoft_account_not_found_in_platform",{message: errorMessage});
            }
        }
    };

    return (
        <div>

            <button className='google-btn mt-4'  onClick={handleLogin}>
                { loading ? <Spin size="small" /> : <img alt="ms-icon" className='icon img-google' src={msIcon}  />}                    
                <span className='responsive-google-text' style={{ fontFamily: 'Poppins', fontWeight: 'bold', color: global_var.loginPageConf.loginPageFontColor ? global_var.loginPageConf.loginPageFontColor : 'rgb(31 31 31)' }}>
                    &nbsp;
                    { global_var.loginPageConf?.microsoftLoginBtnText ? global_var.loginPageConf.microsoftLoginBtnText : "Sign in with Microsoft" }
                </span>
            </button>
            
        </div>
    );
  
};

export default MicrosoftLogin;
